// Formatted text in a lesson: what the hidden parts say to a screen reader.

import { defineMessages } from './index'

export default defineMessages(
  {
    revealSpoiler: 'Yashirin matnni ko‘rsatish',
  },
  {
    en: {
      revealSpoiler: 'Show the hidden text',
    },
    ru: {
      revealSpoiler: 'Показать скрытый текст',
    },
    de: {
      revealSpoiler: 'Verborgenen Text anzeigen',
    },
  },
)
